import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import project1 from '../../../images/project1.png';
import project2 from '../../../images/project2.png';
import project3 from '../../../images/project3.png';
import project4 from '../../../images/project4.png';
import project5 from '../../../images/project5.png';
import './MyProjects.css'

const MyProjects = () => {
    const navigate = useNavigate();
    const handleOnClick = index => {
        const url = `/myProjects/${index}`
        navigate(url);
    }
    return (
        <Container>
            <Typography id="myProjects" style={{fontWeight: 600, fontSize: '280%', margin: '10px auto', textAlign: 'center', marginBottom: 30}} variant="h2" component="div" gutterBottom>
                My Projects
            </Typography>
            <Paper elevation={8} style={{backgroundColor: '#def7e5'}}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} md={6}>
                    <img style={{width: '100%'}} src={project1} alt="" />
                </Grid>
                <Grid item xs={12} md={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <Typography style={{fontWeight: 600, marginBottom: '1px', fontSize: '280%', textAlign: 'center'}} variant="h2" component="div" gutterBottom>
                        Clockroach
                    </Typography>
                    <Box sx={{mt: 3, mb: 2}}>
                        <Button onClick={()=>handleOnClick(0)} className="btnGrad" variant="contained" style={{marginRight: 20}}>Details</Button>
                    </Box>
                </Grid>
            </Grid>
            </Paper>
            <Paper elevation={8} sx={{mt: 8}} style={{backgroundColor: '#f5f5f5'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={12} md={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Typography style={{fontWeight: 600, marginBottom: '1px', fontSize: '280%', textAlign: 'center'}} variant="h2" component="div" gutterBottom>
                        Tourara
                        </Typography>
                        <Box sx={{mt: 3, mb: 2}}>
                            <Button onClick={()=>handleOnClick(1)} className="btnGrad" variant="contained" style={{marginRight: 20}}>Details</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: '100%'}} src={project2} alt="" />
                    </Grid>
                </Grid>
            </Paper>
            <Paper elevation={8} sx={{mt: 8}} style={{backgroundColor: '#def7e5'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={12} md={6}>
                        <img style={{width: '100%'}} src={project4} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Typography style={{ fontWeight: 600, marginBottom: '1px', fontSize: '280%', textAlign: 'center' }} variant="h2" component="div" gutterBottom>
                        Ambicioz Medical
                        </Typography>
                        <Box sx={{mt: 3, mb: 2}}>
                            <Button onClick={()=>handleOnClick(2)} className="btnGrad" variant="contained" style={{marginRight: 20}}>Details</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            <Paper elevation={8} sx={{mt: 8}} style={{backgroundColor: '#f5f5f5'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={12} md={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Typography style={{fontWeight: 600, marginBottom: '1px', fontSize: '280%',textAlign: 'center'}} variant="h2" component="div" gutterBottom>
                        Amfly
                        </Typography>
                        <Box sx={{mt: 3, mb: 2}}>
                        <Button onClick={()=>handleOnClick(3)} className="btnGrad" variant="contained" style={{marginRight: 20}}>Details</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <img style={{width: '100%'}} src={project3} alt="" />
                    </Grid>
                </Grid>
            </Paper>
            <Paper elevation={8} sx={{mt: 8}} style={{backgroundColor: '#def7e5'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={12} md={6}>
                        <img style={{width: '100%'}} src={project5} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Typography style={{fontWeight: 600, marginBottom: '1px', fontSize: '280%', textAlign: 'center'}} variant="h2" component="div" gutterBottom>
                            Skillup
                        </Typography>
                        <Box sx={{mt: 3, mb: 2}}>
                        <Button onClick={()=>handleOnClick(4)} className="btnGrad" variant="contained" style={{marginRight: 20}}>Details</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default MyProjects;